// ── usePrompt — спросить строку в нашем окне вместо системного prompt() ──────
//   const [promptEl, askText] = usePrompt();
//   const v = await askText({ title: t("С какого времени?"), placeholder: "30:00" });
//   if (v === null) return;   — закрыли или «Отмена»
//   {promptEl}

import { useCallback, useState } from 'react';
import { t } from '../i18n';
import Button from './Button';
import { Modal } from './Dialog';
import Field from './Field';

function PromptDialog({ title, body, label, placeholder, initial = '', okLabel, onDone, C }) {
  const [v, setV] = useState(initial);
  return (
    <Modal C={C} size="sm" title={title} onClose={() => onDone(null)}
      footer={<><Button C={C} onClick={() => onDone(null)}>{t("Отмена")}</Button><Button C={C} variant="primary" onClick={() => onDone(v)}>{okLabel || t("Готово")}</Button></>}>
      {body && <div style={{ fontSize: 14, lineHeight: 1.5, marginBottom: 12, overflowWrap: 'break-word' }}>{body}</div>}
      <Field C={C} label={label} aria-label={label || title} value={v} placeholder={placeholder} autoFocus style={{ marginBottom: 0 }}
        onChange={(e) => setV(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter') onDone(v); }} />
    </Modal>
  );
}

export default function usePrompt(C) {
  const [req, setReq] = useState(null);
  const askText = useCallback((opts) => new Promise((resolve) => setReq({ ...opts, resolve })), []);
  const el = req ? <PromptDialog C={C} {...req} onDone={(v) => { req.resolve(v); setReq(null); }} /> : null;
  return [el, askText];
}
